import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=7619ab15&scoped=true&"
import script from "./user-avatar.vue?vue&type=script&lang=ts&"
export * from "./user-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=7619ab15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7619ab15",
  null
  
)

export default component.exports